import { Component, Input, OnChanges } from '@angular/core';
import { GainsToastService } from '../../../services/gains-toast-service/gains-toast.service';
import { highlightJson } from './json-highlight';

/** Past this many characters (some 70 orders of a PO Submit) JSON is shown plain: coloured, its hundreds of thousands
 * of spans would hold the page for seconds. */
export const HIGHLIGHT_LIMIT = 200_000;

/** JSON shown as editors colour it, with a button that copies it as it is. */
@Component({
  selector: 'gains-json-viewer',
  standalone: false,
  templateUrl: './gains-json-viewer.component.html',
  styleUrl: './gains-json-viewer.component.scss'
})
export class GainsJsonViewerComponent implements OnChanges {
  @Input() json: string | null | undefined = '';
  @Input() copyable = true;
  @Input() highlightLimit = HIGHLIGHT_LIMIT;

  html = '';
  /** Whether it is shown plain, too large to colour; until asked to colour it anyway. */
  plain = false;

  constructor(private readonly _toast: GainsToastService) {}

  ngOnChanges(): void {
    const json = this.json ?? '';
    this.plain = json.length > this.highlightLimit;
    this.html = this.plain ? '' : highlightJson(json);
  }

  colourAnyway(): void {
    this.plain = false;
    this.html = highlightJson(this.json ?? '');
  }

  /** `1.4 MB`, the size the notice of a plain JSON gives. */
  get size(): string {
    const length = this.json?.length ?? 0;
    return length >= 1_000_000 ? `${(length / 1_000_000).toFixed(1)} MB` : `${Math.round(length / 1000)} KB`;
  }

  copy(): void {
    navigator.clipboard.writeText(this.json ?? '').then(
      () => this._toast.message('JSON copied to clipboard.', 'success'),
      error => {
        console.error('Error copying JSON:', error);
        this._toast.message('Failed to copy the JSON to the clipboard.', 'error');
      }
    );
  }
}
